import React from 'react';

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { Theme, Box } from '@mui/material';

import Navbar from 'components/Navbar';
import Footer from 'components/Footer';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'grid',
            gridTemplateRows: 'auto 1fr',
        },
        content: {
            padding: theme.spacing(1),
        },
    }),
);

interface PageProps {
    style?: React.CSSProperties;
    className?: string;
    children?: React.ReactNode;
}

const Page: React.FC<PageProps> = ({ style, className, children }) => {
    const classes = useStyles();

    return (
        <Box className={classes.root}>
            <Box
                sx={{
                    display: 'grid',
                    minHeight: '100vh',
                    gridTemplateRows: 'auto 1fr auto',
                }}
            >
                <Navbar />
                <Box
                    className={`${classes.content} ${className ?? ''}`}
                    style={style}
                >
                    {children}
                </Box>
                <Footer />
            </Box>
        </Box>
    );
};

Page.displayName = 'Page';
export default Page;
